// extracted by mini-css-extract-plugin
export default {"skeleton":"style_skeleton__cPWX3","pulse":"style_pulse__uhazP"};